/**
 * Bing is a retired imagery source. Designs that already use their saved Bing image keep it,
 * but Bing is never offered as a new choice or picked by a fallback.
 */
export const RETIRED_IMAGERY_SOURCE = `bing`

/** Accepts a provider (`bing`) or an image key (`bing (Jan 1, 2024)`). */
export const isRetiredImagerySource = (
  sourceOrKey: string | null | undefined,
): boolean => sourceOrKey?.includes(RETIRED_IMAGERY_SOURCE) ?? false

/**
 * Whether `sourceOrKey` may be shown as an image choice for a Design currently displaying
 * `currentSourceOrKey`. Bing stays visible only while it is the current selection.
 */
export const isOfferedImagerySource = (
  sourceOrKey: string,
  currentSourceOrKey: string | null | undefined,
): boolean =>
  !isRetiredImagerySource(sourceOrKey) ||
  isRetiredImagerySource(currentSourceOrKey)
